import { TeamsResponse, createTeamsPayload, updateTeamsPayload } from '../features/tags/tagsType';
import { del, get, post, put } from '../utils/api';
import { formatUrl } from '../utils/urlFormatter';


const fetch_locations = '/{0}/tag.list';
const create_locations = '/{0}/tag.add';
const update_location = '/{0}/{1}/tag.update';
const fetch_locations_status = '/{0}/tag.list';
const fetch_pipeline_details = '/{0}/{1}/tag.detail'
const delete_location = '/{0}/{1}/tag.delete'

const credentialsConfig = {
    withCredentials: true,
}


export const fetchLocationData = async (baseId: number, tag_type?: string): Promise<TeamsResponse> => {
    let fetch_location_data = formatUrl(fetch_locations, [baseId]);
    if (tag_type) {
        fetch_location_data += `?tag_type=${encodeURIComponent(tag_type)}`;
    }
    return get<TeamsResponse>(fetch_location_data, credentialsConfig);
};

export const fetchLocationDataStatus = async (baseId: number, status?: string): Promise<TeamsResponse> => {
    let fetch_location_data = formatUrl(fetch_locations_status, [baseId]);
    if (status) {
        fetch_location_data += `?status=${status}`;
    }
    return get<TeamsResponse>(fetch_location_data, credentialsConfig);
};


export const createLoationData = async (data: createTeamsPayload, userId: number): Promise<TeamsResponse> => {
    const base_create_location = formatUrl(create_locations, [userId]);
    return post<TeamsResponse>(base_create_location, data, credentialsConfig);
};


export const updateLocationData = async (id: number, baseId: number, data: updateTeamsPayload): Promise<TeamsResponse> => {
    const update_teams_data = formatUrl(update_location, [id, baseId]);
    return put<TeamsResponse>(update_teams_data, data, credentialsConfig);
};

export const fetchPipelineDetails = async (baseId: number, userId: string): Promise<TeamsResponse> => {
    const fetch_pipeline_details1 = formatUrl(fetch_pipeline_details, [baseId, userId]);
    return get<TeamsResponse>(fetch_pipeline_details1, credentialsConfig);
};


// delete 
export const deleteLocationData = async (id: number, baseId: number): Promise<TeamsResponse> => {
    const delete_location_data = formatUrl(delete_location, [id, baseId]);
    return del<TeamsResponse>(delete_location_data, credentialsConfig);
};